import classNames from 'classnames'
import { forwardRef, HTMLAttributes, useContext } from 'react'

import { TableContext } from './context'
import styles from './table-footer.module.scss'

export type TableFooterElement = HTMLTableSectionElement

export type TableFooterProps = HTMLAttributes<TableFooterElement>

const TableFooter = forwardRef<TableFooterElement, TableFooterProps>(function TableFooter(
  props,
  ref
) {
  const { className, ...rest } = props
  const classes = classNames(styles.root, className)
  const ctx = useContext(TableContext)
  return (
    <TableContext.Provider
      value={{
        ...ctx,
        getCellStyles(opts) {
          return ctx.getCellStyles({ ...opts, noBorder: true })
        },
      }}
    >
      <tfoot {...rest} className={classes} ref={ref} />
    </TableContext.Provider>
  )
})

export default TableFooter
